import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Invalide le cache storefront Next.js après une modification admin.
 *  Appelle l'API /api/revalidate du storefront.
 */
export async function revalidateStorefront(path = "/"): Promise<void> {
  const STOREFRONT_URL = import.meta.env.VITE_STOREFRONT_URL ?? (typeof window !== "undefined" ? `${window.location.protocol}//${window.location.hostname}:3000` : "http://localhost:3000");
  const SECRET = import.meta.env.VITE_INTERNAL_API_SECRET ?? "flexfit-internal-secret-2026";
  try {
    const res = await fetch(`${STOREFRONT_URL}/api/revalidate`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${SECRET}` },
      body: JSON.stringify({ path }),
      signal: AbortSignal.timeout(3000),
    });
    if (res.ok) console.log("[revalidateStorefront] cache storefront invalidé");
  } catch {
    // Storefront hors ligne (dev) — les données sont déjà en DB, le cache expirera automatiquement.
  }
}